exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-dialog-toolbar {\n    z-index: 10;\n}\n#contact-group-speed-dialog {\n    -webkit-transform: translateY(70px);\n            transform: translateY(70px);\n}\n#contact-group-speed-dialog > .v-btn--floating .v-btn__content {\n    height: 28px;\n}\n", ""]);

// exports
